export default{
    newsThreeTitle: "大数据下的网贷风控，靠谱吗？",
    newsTime: "发布时间",
    newsRead:"阅读量",
    newsThreeSource:"文章来源：",
    newsThreeDetail:[
        {
            p:"现金贷和消费金融真是个大蛋糕，诱人可口，很多资本大佬也紧盯着这块市场，竞争激烈，要是没两把刷子，还真玩不转。"
        },
        {
            p:"拿两把刷子呢？一个是资本，另一个是大数据风控。"
        },
        {
            p:"那么，今天我们就来聊聊，这个大数据风控，靠谱吗？"
        },
        {
            p:"大数据风控，听上去，好高大上啊，虽然不知道啥意思，但就是觉得有逼格。"
        },
        {
            h4:"这大数据风控，到底是个啥？"
        },
        {
            p:"其实大数据风控并不神秘，它和传统风控的本质是差不多的，只是在风控模型中多加了些维度和关联性分析。"
        },
        {
            p:"举个简单点例子，传统的风控，判断一个人是否具备贷款资质，常常会审核他的存款，收入，抵押物，家庭情况以及征信状况等等。这种信用风险管理方式也可以称为白名单制，就是设立了一些准入门槛，如果你达不到要求的话，那就不能申请借款。"
        },
        {
            p:"而大数据风控可以参考的数据往往更丰富，它们不仅会考虑这些金融数据，还会引入借款人的社交数据，比如微信，微博的活跃状态，关注的相关话题等等，支付数据，比如购买力，消费习惯，消费金额等以及其他一些生活服务类数据，如交通数据，饮食习惯等。"
        },
        {
            p:"通过这些数据，能够更加形象地刻画出申请人的经济形象和社会形象，可以把筛选人群基数进一步扩大。这种信用风险管理方式俗称为黑名单制，就是设立了一些雷区，只要你不具备这些污点，那就可以申请借款。"
        },
        {
            p:"听起来，挺简单的，感觉这也没啥。"
        },
        {
            p:"但事实上，大数据风控是具有深刻影响意义的，它将金融服务平民化，让更多普通老百姓能够享受到这种便利。"
        },
        {
            p:"说句不中听话，要是按照传统金融风控的严格要求，估计有不少读者都不能顺利借到钱，享受不到金融服务。当然，这不是说你是劣质客户，是要当老赖的，可能仅仅是因为你是白户，没有啥金融数据可参考，为了规避风险，就只能将你排除。"
        },
        {
            p:"可是，大数据风控就人性多了，它们不会只盯着你某一项数据，它们会全面衡量你的还款能力，还款意愿等等，从而给出一个较为中肯的评价和借款额度。"
        },
        {
            p:"这样做的好处，不仅方便了普通用户，让他们享受到了金融服务，而且也扩大了放贷市场容量，大大促进了金融发展！"
        },
        {
            p:"不过，大数据风控看着很美好，但真要做起来也不是一件容易的事。"
        },
        {
            h4:"首先数据要全面。"
        },
        {
            p:"大数据，不是说数据量要有多大，而是数据覆盖要全面。不然无关紧要的数据就算给得再多也没有用的。甚至维度都有可能缺失，就像判断一个人身材是否良好，只知身高，不知体重，那有啥用？"
        },
        {
            p:"据我所知，目前网贷行业就有一部分平台，它们所谓的大数据风控纯属摆设，没啥用的，口号喊得天响，实际意义根本没有，玩的就是一个噱头。"
        },
        {
            p:"不过，也幸好，它们只是玩玩噱头，要是真的按照样本不全的大数据来搞风控，那早晚死翘翘。"
        },
        {
            h4:"然后是防诈骗问题。"
        },
        {
            p:"这个常见于个人信用贷上，一般来说，一个人借了几千块钱，平台方怕的不是他还不起，而是不想还，甚至就是来骗钱的。换一句话说，借款人不光要有还款能力，还得具备还款意愿啊，否则这钱不管多少，都是收不回来的。"
        },
        {
            p:"这就是考验平台大数据风控能力的时候，你要在茫茫多的借款人中甄别出哪些是老赖，哪些是诈骗犯？"
        },
        {
            p:"这确实是一个挑战，尤其当这个平台刚起步，没有相应的数据样本时，那么多坑，真的很难避免。"
        },
        {
            p:"更可怕的是，在网贷行业还有一条隐蔽的黑色产业链——骗贷。骗贷大军有时会用以点破面的方法，通过平台对单个借款人的审核，从而推敲出平台整个大数据风控模型的漏洞，进行大规模骗贷；有时又会和平台内部人员相互勾结，进行诈骗，简直是防不胜防。"
        },
        {
            h4:"最后是数据新鲜度问题。"
        },
        {
            p:"大数据，既要解决广度问题，包含借款人经济、生活行为的方方面面，又要解决深度问题，突出显示借款人的关联数据，着重刻画人物形象。"
        },
        {
            p:"广度和深度是大数据的基本框架，但还有一个点不能忽略，那就是数据的新鲜度问题。"
        },
        {
            p:"新鲜度，自然数据越新越好，最好能做到时时监控，一旦出现借款人逾期（或不想还款）的不良信号时，能够及时采取提醒，警示，催收等应急措施。"
        },
        {
            p:"只有把大数据在贷前，贷中，贷后各个阶段合理有效利用起来，才能够发挥它真正的价值，为投资人的资金安全保驾护航。"
        },
        {
            p:"当然，大家也要明白一点，大数据风控不是万能的，在实际的运用过程中也要不断修补完善，才能应对复杂多变的网贷环境。"
        },
        {
            p:"好了，今天就简单说到这里，大数据风控是一个很复杂的话题，三言两语很难说清楚，有时间，有机会的话，我们再来讨论。"
        },
        {
            p:"至于如何判断平台大数据风控是否靠谱？主要还是看平台的坏账率，但现实又很尴尬，大部分网贷平台对于逾期率一直遮遮掩掩的，我们无法得知真实数据。"
        },
        {
            p:"所以，我们只能根据平台的规模和资金量来做个粗略的判断。一般来说，平台实力越强，得到的数据源可能会越好，风控模型的搭建也可能越完善，风险相对会更小。当然，这个也不绝对，只是作为一个参考。"
        },
        {
            h4:"再提醒一句，大数据风控多运用在个人信用贷，消费金融上，像汽车贷，企业贷，房抵贷等资产端暂时不多考虑。"
        },
       

    ]
}